/**
 * 언어 판정. **`navigator` 도 `localStorage` 도 직접 만지지 않는다** — 값을 인자로 받는다
 * (`docs/22` §2.3). 두 앱이 node 환경에서 테스트하므로(jsdom 미도입) DOM 을 만지는 순간
 * 이 규칙이 검사에서 통째로 빠진다.
 *
 * **규칙이 하나여야 하는 이유**: 콘솔과 앱이 각자 판정하면 「콘솔은 영어인데 앱은
 * 한국어」가 된다. 두 앱은 컴포넌트를 공유하지 않지만(`docs/06`) 이 규칙은 공유한다.
 */
export const LOCALES = ['ko', 'en'];
/**
 * **기본값은 영어다.** 「시스템 언어가 한국어가 아니면 모두 영어」가 사용자 지시이고
 * (`docs/22` D2), 그 「그 밖 전부」의 자리가 이 값이다.
 */
export const DEFAULT_LOCALE = 'en';
export function isLocale(value) {
    return typeof value === 'string' && LOCALES.includes(value);
}
/**
 * BCP 47 태그가 한국어인가.
 *
 * **`startsWith('ko')` 로 짜면 틀린다** — `kok`(Konkani)·`kos`(Kosraean)가 걸린다.
 * 앞 서브태그만 정확히 비교한다. 반대로 서브태그가 몇이든(`ko-Kore-KR`) 앞의 `ko` 만 본다.
 */
export function isKorean(tag) {
    return tag.toLowerCase().split('-')[0] === 'ko';
}
/**
 * 3단계 우선순위 (`docs/22` §2.1).
 *
 * ```
 * 1) query   유효하면 그 값
 * 2) saved   유효하면 그 값
 * 3) system  첫 항목이 한국어면 'ko'
 * 4) 그 밖은 전부 'en'
 * ```
 *
 * **`systemLanguages` 의 첫 항목만 보는 이유.** `['en-US', 'ko-KR']` 인 사람은 영어를
 * **먼저** 두었다는 뜻이다. 목록 전체를 훑어 한국어를 찾아내면 그 의도를 뒤집는다.
 */
export function resolveLocale(input = {}) {
    if (isLocale(input.query))
        return input.query;
    if (isLocale(input.saved))
        return input.saved;
    const primary = input.systemLanguages?.[0];
    if (typeof primary === 'string' && isKorean(primary))
        return 'ko';
    return DEFAULT_LOCALE;
}
//# sourceMappingURL=locale.js.map